import { gql } from "@apollo/client";
export const GET_EMAIL_TEMPLATES = gql`
query GetAllEmailTemplates($type: String) {
  getAllEmailTemplates(type: $type) {
    template_id
    template_name
    module
  }
}
`
export const SEND_EMAIL_TO_MEMBER = gql`
mutation SendEmailToMember($input: sendEmailToMemberInput) {
  sendEmailToMember(input: $input) {
    success
    message
    error
  }
}
`